import { moveToFulfilled, moveToPending, moveToRejected, update } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type { AddUpvotePending, RemoveUpvotePending } from '../../domains/messageAddRemoveUpvote/actions.types';
import type {
  MessageUpvotesLoadFulfilledAction,
  MessageUpvotesLoadMoreFulfilledAction,
  MessageUpvotesLoadPendingAction,
  MessageUpvotesLoadRejectedAction,
} from '../../domains/messageUpvoteLoad/actions.types';

import type { MessageUpvotes } from './types';

export type MessageUpvotesLoadAction =
  | MessageUpvotesLoadFulfilledAction
  | MessageUpvotesLoadRejectedAction
  | MessageUpvotesLoadPendingAction
  | MessageUpvotesLoadMoreFulfilledAction
  | AddUpvotePending
  | RemoveUpvotePending;

const initialState: MessageUpvotes = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const appendMessageUpvotes = (
  state: MessageUpvotes,
  { messageId, entities }: MessageUpvotesLoadMoreFulfilledAction['payload']
) => {
  const answerUpvotes = entities.answerUpvotes[messageId];

  const updatedMessageUpvotes = {
    cursor: answerUpvotes.cursor,
    hasNextPage: answerUpvotes.hasNextPage,
    userIds: state.fulfilled.byId[messageId].userIds.concat(answerUpvotes.userIds),
  };

  return update(state, messageId, updatedMessageUpvotes);
};

const reducer: Reducer<MessageUpvotes, MessageUpvotesLoadAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'MESSAGE_UPVOTES.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.answerUpvotes);
    case 'MESSAGE_UPVOTES.LOAD_PENDING':
      return moveToPending(state, [action.payload.messageId]);
    case 'MESSAGE_UPVOTES.LOAD_REJECTED':
      return moveToRejected(state, [action.payload.messageId], action.payload.error);
    case 'MESSAGE_UPVOTES.LOAD_MORE_FULFILLED':
      return appendMessageUpvotes(state, action.payload);
    default:
      return state;
  }
};

export default reducer;
